import React from "react";
import { SensitiveContent, SensitiveContentProps } from "../../../SensitiveContent/SensitiveContent";

export interface SensitiveContentColumnProps {
    /**
     * sensitive content props to create <SensitiveContent /> element
     */
    readonly sensitiveContentProps: SensitiveContentProps;
}

export const SensitiveContentColumn: React.FC<SensitiveContentColumnProps> = ({
    sensitiveContentProps
}) => {
    return (
        <SensitiveContent {...sensitiveContentProps} />
    );
};
